import React, { useEffect, useState } from "react";

import EcoLogoWhite from "../../../img/eco/logo-white.png";
import { getPrivacyApi, type PrivacyInfo } from "../campanhasApi";
import "./Candidatura.css";

/**
 * Política de privacidade dos candidatos (pública). Texto fixo; quem trata os
 * dados, o CNPJ e o contato vêm de Administração → Configurações → Campanhas.
 * É também a URL que a Meta exige para ativar o app.
 */
const PoliticaPrivacidadePage: React.FC = () => {
  const [info, setInfo] = useState<PrivacyInfo | null>(null);
  const [failed, setFailed] = useState(false);

  useEffect(() => {
    document.title = "Política de Privacidade";
    getPrivacyApi()
      .then(setInfo)
      .catch(() => setFailed(true));
  }, []);

  const controller = info?.controllerName || "a empresa responsável pela vaga";
  const cnpj = info?.controllerCnpj;
  const contact = info?.contact;

  return (
    <div className="candPage">
      <header className="candHeader">
        <div className="candHeader__inner">
          <img className="candHeader__logo" src={EcoLogoWhite} alt="Eco System Serviços" />
          <h1 className="candHeader__title">Política de Privacidade</h1>
        </div>
      </header>
      <main className="candMain">
        {failed ? <p className="candError">Não foi possível carregar os dados da empresa. Tente de novo mais tarde.</p> : null}
        <article className="candCard candPolicy">
          <p>
            Esta política explica como {controller}
            {cnpj ? ` (CNPJ ${cnpj})` : ""} trata os dados de quem se candidata às vagas de freelancer divulgadas no Facebook e no Instagram, de acordo
            com a Lei Geral de Proteção de Dados (Lei 13.709/2018).
          </p>

          <h2>Quais dados coletamos</h2>
          <p>
            Os que você informa no formulário de candidatura: nome, CPF, celular, e-mail (se informar), cidade, bairro, as respostas às perguntas da vaga
            e o currículo (se enviar). Também registramos de qual anúncio você veio.
          </p>

          <h2>Para que usamos</h2>
          <p>
            Para avaliar a sua candidatura, entrar em contato sobre esta e outras vagas de freelancer e, se você for aprovado, fazer o seu cadastro. A
            base legal é o seu consentimento, dado ao marcar o aceite no formulário.
          </p>

          <h2>Com quem compartilhamos</h2>
          <p>
            Os dados ficam no nosso sistema e só a equipe responsável pelas contratações tem acesso. Não vendemos nem repassamos os seus dados. A Meta
            (Facebook e Instagram) não recebe o que você preenche no formulário.
          </p>

          <h2>Por quanto tempo guardamos</h2>
          <p>
            Se você não for aprovado, os dados e o currículo são apagados automaticamente depois do prazo de guarda informado no formulário. Se for
            aprovado, os dados passam a fazer parte do seu cadastro.
          </p>

          <h2>Seus direitos</h2>
          <p>
            Você pode pedir acesso, correção ou exclusão dos seus dados e retirar o consentimento a qualquer momento
            {contact ? (
              <>
                {" "}
                pelo e-mail{" "}
                <a className="candLink" href={`mailto:${contact}`}>
                  {contact}
                </a>
              </>
            ) : null}
            .
          </p>
        </article>
      </main>
    </div>
  );
};

export default PoliticaPrivacidadePage;
